import './cityspotters-story.css'
import './static/choose.svg'
import './static/discover.svg'
import './static/enjoy.svg'
